import { useRef } from 'react';
import { useMap } from 'react-leaflet';
import _ from 'lodash';

var ChangeView = function ChangeView(_ref) {
  var center = _ref.center,
      zoom = _ref.zoom;
  var temCenter = useRef({
    lat: '',
    lng: ''
  });
  if (_.isEmpty(center) || temCenter.current.lat === center.lat && temCenter.current.lng === center.lng) return null;
  temCenter.current = center;
  var map = useMap();
  map.setView(center, zoom);
  return null;
};

export default ChangeView;